<template>
  <div class="hcl-toolbar-content-list-column-selector">
    <hcl-dropdown
      v-if="chooserDropdownMenuItemsSelectableCount > 0"
      ref="chooserDropdownRef"
      :title="chooserDropdownText"
      id="fields-menu-table"
      icon="eii--fa6-solid--table-columns"
      :responsive=false
      button-class="btn-outline-default ml-2"
    >
      <template v-for="column in columnsFlattened">
        <a
          class="dropdown-item"
          :class="{ disabled: column.required }"
          v-if="column.name !== 'checkbox'"
          :key="column.name"
          :disabled="column.required"
          @click="onColumnsMenuSelectionChange(column)"
        >
          <i
            v-if="!column.hidden"
            class="eii--fa6-solid--square-check"
          ></i>
          <i
            v-if="column.hidden"
            class="eii--fa6-regular--square"
          ></i>
          {{ column.title }}
        </a>
      </template>
    </hcl-dropdown>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, inject } from 'vue'

import type { Ref } from 'vue'

import { useColumns } from './columns'

import HclDropdown from '@/components/Dropdown/Dropdown.vue'

import { DefinitionListContentColumn, DataToolbar, DefinitionToolbarContentListColumnSelector } from '@/components/types'

interface Props {
  /**
   * Definition as an JS object.
   */
  definition: DefinitionToolbarContentListColumnSelector
}

const props = withDefaults(defineProps<Props>(), {
  definition: undefined
})

const columnsRef: Ref<DefinitionListContentColumn[]> = inject('columnsRef', ref([]))
const listMetaId: string = inject('listMetaId', '')

const chooserDropdownRef = ref()

const chooserDropdownText = computed(() => {
  return props.definition.choosertext ?? 'Spaltenoptionen'
})

const {
  columnsFlattened,
  onColumnsMenuSelectionChange,
} = useColumns(
  listMetaId,
  columnsRef
)

const chooserDropdownMenuItemsSelectableCount = computed(() => {
  return columnsRef.value.length
})
</script>

<style lang="scss" scoped>
.hcl-toolbar-content-list-column-selector {
  display: flex;
  justify-content: flex-end;

  .pagination {
    margin-bottom: 0;
  }
}
</style>
